// Header.js
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import BurgerMenu from './BurgerMenu';
import SideBar from './SideBar';
import './Header.css';
import logo from './assets/logo.png';

function Header() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(prev => !prev);
  };

  return (
    <>
      <header className="header-container">
        <div className="header-wrapper">
          {/* Left Section: Logo */}
          <div className="header-left">
            <img src={logo} alt="Logo" className="header-logo" />
          </div>


          {/* Right Section: Navigation + Burger Menu */}
          <div className="header-right">
            <nav className="desktop-nav">
              <ul>
                <li>
                  <Link to="/"><span>Home</span></Link>
                </li>
                <li>
                  <Link to="/about"><span>About</span></Link>
                </li>
                <li>
                  <Link to="/contactus"><span>Contact</span></Link>
                </li>
                <li>
                  <Link to="/quote"><span>Request a Quote</span></Link>
                </li>
                <li>
                  <Link to="/flight-tracker"><span>Secure Upload</span></Link>
                </li>
              </ul>
            </nav>
            <div className="burger-menu-container">
              <BurgerMenu isOpen={sidebarOpen} onClick={toggleSidebar} />
            </div>
          </div>
        </div>
      </header>

      <SideBar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
    </>
  );
}

export default Header;